'use client';
import dynamic from 'next/dynamic';

const GoogleTagMan = dynamic(() => import('@/components/GoogleTagMan'), {
  ssr: false,
});

export default function GoogleTagManClient() {
  return <GoogleTagMan />;
}